<template>
    <v-row v-if="service" class="borderbottom">
        <v-col sm="8" class="py-0">
            <span style="font-weight: bold">{{ locale === 'fr' ? service.beschreibungFr : service.beschreibungDe }}</span>
        </v-col>
        <v-col sm="2" class="py-0">{{ service.limiteGigaByte }} GB</v-col>
        <v-col sm="2" class="py-0" style="text-align: right">{{ service.preisProMonat.toFixed(2) }}</v-col>
    </v-row>
    <v-row v-else class="borderbottom">
        <v-col sm="8" class="py-0">
            <span style="font-weight: bold">{{ $t('einstellungen.services.noservicesadded') }}</span>
        </v-col>
        <v-col sm="2" class="py-0">-</v-col>
        <v-col sm="2" class="py-0" style="text-align: right">0.00</v-col>
    </v-row>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { ServiceApiDto } from '@/api-schema';

@Component
export default class ServiceRow extends Vue {
    @Prop({ required: true, type: Object })
    private service!: ServiceApiDto;

    private get locale(): string {
        return this.$i18n.locale; // Access the current locale from Vue i18n instance
    }
}
</script>
